module.exports = __webpack_public_path__ + "static/media/whatsapp.5af5f51f.svg";